import { render, staticRenderFns } from "./ProformToInvoiceView.vue?vue&type=template&id=2ea8dbff&scoped=true&"
import script from "./ProformToInvoiceView.vue?vue&type=script&lang=ts&"
export * from "./ProformToInvoiceView.vue?vue&type=script&lang=ts&"
import style0 from "./ProformToInvoiceView.vue?vue&type=style&index=0&id=2ea8dbff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea8dbff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
